export default __webpack_public_path__ + "static/media/3.7b1e81df.jpg";